var _clipPath, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 960.0 540.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l960.0 0l0 540.0l-960.0 0l0 -540.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l960.0 0l0 540.0l-960.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b98cf6",
    d: "m305.23383 167.60527l178.43353 48.16977l-8.746094 32.201508l-178.4335 -48.169754z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b98cf6",
    d: "m423.70322 210.13503l0 0c-22.139038 -38.551193 -8.834351 -87.75032 29.716827 -109.88934l0 0c18.512909 -10.631538 40.490967 -13.473396 61.099243 -7.9004135c20.608215 5.5729904 38.15857 19.104317 48.7901 37.61724l0 0c22.139038 38.551178 8.834351 87.75032 -29.716858 109.88934l0 0c-38.551178 22.139023 -87.750305 8.834351 -109.88931 -29.716827zm29.575562 -16.984558l0 0c12.758728 22.217056 41.112183 29.884537 63.329193 17.125824c22.217041 -12.758728 29.884583 -41.112183 17.125854 -63.329224c-12.758728 -22.217049 -41.112213 -29.884537 -63.329254 -17.125824l0 0c-22.217041 12.758728 -29.884521 41.112183 -17.125793 63.329224z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b98cf6",
    d: "m684.46704 385.89648l-178.4335 -48.16977l8.746124 -32.201508l178.43347 48.16977z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b98cf6",
    d: "m565.9977 343.36673l0 0c22.139038 38.551178 8.834351 87.750305 -29.716797 109.88934l0 0c-18.51294 10.631531 -40.490997 13.473389 -61.099243 7.900421c-20.608246 -5.572998 -38.15857 -19.10434 -48.7901 -37.61725l0 0c-22.139038 -38.551178 -8.834351 -87.750305 29.716827 -109.88934l0 0c38.551178 -22.139038 87.750336 -8.834351 109.88931 29.716827zm-29.575562 16.984558l0 0c-12.758728 -22.217041 -41.112152 -29.884552 -63.329224 -17.125824c-22.217041 12.758728 -29.884521 41.112183 -17.125793 63.329224c12.758728 22.217041 41.112183 29.884521 63.329224 17.125824l0 0c22.217041 -12.758728 29.884521 -41.112183 17.125793 -63.329224z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b98cf6",
    d: "m538.0065 361.62784l-111.71146 -147.29213l26.834595 -20.275024l111.71146 147.29213z",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.83373288bc86be337b0b945a0db0fdea.svg";
export { ForwardRef as ReactComponent };